// @flow
import { get } from 'lodash';
import { resolve } from 'redux-optimist-promise';

import { CLEAR_PROPOSALS, FETCH_PROPOSALS } from 'Store/booking/proposals/constants';

type State = {
  dates: Array<DateSuggestion>,
  durations: Array<DurationSuggestions>,
  resorts: Array<ResortSuggestion>,
};

const initialState: State = {
  dates: [],
  durations: [],
  resorts: [],
};

export function suggestionsReducer(state: State = initialState, action: Action<*>): ?State {
  switch (get(action, 'type')) {
    case resolve(FETCH_PROPOSALS): {
      const dates = get(action, 'payload.proposals.dateSuggestion', []);
      const durations = get(action, 'payload.proposals.durationSuggestions', []);
      const resorts = get(action, 'payload.proposals.suggestions', []);
      return {
        ...state,
        dates,
        resorts,
        durations,
      };
    }
    case CLEAR_PROPOSALS:
      return initialState;
    default:
      return state;
  }
}
